import PropTypes from "prop-types";
import { useState, useCallback, useEffect } from "react";
import {
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Form,
    Button,
    Spinner,
} from "reactstrap";

const FormModal = ({
    id,
    form, // Instancia de useForm (react-hook-form)
    size,
    isOpen,
    footer,
    onSubmit,
    children,
    closeModal,
    headerTitle,
    ...props
}) => {
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        isOpen == false ? form.reset() : null;
    }, [isOpen]);

    const sumbitCallback = useCallback(async (e) => {
        e.preventDefault();
        setIsLoading(true);
        const submitFunction = form.handleSubmit(onSubmit);
        await submitFunction();
        setIsLoading(false);
    });

    return (
        <Modal
            {...props}
            isOpen={isOpen}
            size={size ?? "lg"}
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <ModalHeader className="bg-secondary text-white text-bold">
                {headerTitle}
            </ModalHeader>
            <ModalBody>
                <Form onSubmit={sumbitCallback} id={id}>
                    {children}
                </Form>
            </ModalBody>
            <ModalFooter>
                {footer != null ? (
                    footer
                ) : (
                    <>
                        <Button
                            color="secondary"
                            form={id}
                            key="save"
                            type="submit"
                            disabled={isLoading}
                        >
                            {isLoading ? (
                                <Spinner size="sm" />
                            ) : (
                                <i className="fas fa-plus mr-2"></i>
                            )}
                            <span>Guardar</span>
                        </Button>
                        <Button
                            color="primary"
                            key="close"
                            onClick={() => closeModal()}
                        >
                            <i className="fas fa-trash mr-2"></i>
                            Cancelar
                        </Button>
                    </>
                )}
            </ModalFooter>
        </Modal>
    );
};

FormModal.propTypes = {
    id: PropTypes.string,
    form: PropTypes.object, // Instancia de useForm (react-hook-form)
    size: PropTypes.string,
    isOpen: PropTypes.bool,
    footer: PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.node),
        PropTypes.node,
    ]),
    onSubmit: PropTypes.func,
    children: PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.node),
        PropTypes.node,
    ]),
    closeModal: PropTypes.func,
    headerTitle: PropTypes.string,
};

export default FormModal;
